<script>
      import Locale from '../locale/Locale.svelte'
      import BreakpointContext from './BreakpointContext.svelte'
      import PageStateContext from './PageStateContext.svelte'
      import PayloadGlobals from './PayloadGlobals.svelte'
      import Scroll from './Scroll.svelte'
      import Ui from './Ui.svelte'

      let { children = null } = $props()
</script>

<PageStateContext>
      <BreakpointContext>
            <Locale>
                  <PayloadGlobals>
                        <Scroll>
                              <Ui>
                                    {@render children?.()}
                              </Ui>
                        </Scroll>
                  </PayloadGlobals>
            </Locale>
      </BreakpointContext>
</PageStateContext>
